import "layui";
import "layui/dist/css/layui.css";
import $ from "jquery";
import "@/css/footer.scss";

function footers() {
  // 创建 style 标签
  //   const style = document.createElement('style');
  //   style.textContent = `
  // 		.footer {
  //   width: 100%;
  //   height: 398px;
  //   background: #0d1726;
  // }
  // .footer-child1 {
  //   width: 100% !important;
  //   height: 260px !important;
  //   border-bottom: 1px solid #3d4551 !important;
  //   .footer-content {
  //     width: 100%;
  //     max-width: 1208px !important;
  //     margin: auto !important;
  //     display: flex !important;
  //     height: 100% !important;
  //     .footer-content-left {
  //       margin-top: 40px  !important;
  //       width: 907px !important;
  //       height: 210px !important;
  //       border-right: 1px solid #3d4551  !important;
  //       display: flex !important;
  //     }
  //     .footer-content-right {
  //       margin-top: 40px  !important;
  //       width: 301px !important;
  //       height: 210px !important;
  //       position: relative !important;
  //       div {
  //         font-family: HarmonyOS_Sans_SC;
  //         font-weight: 400 !important;
  //         font-size: 15px !important;
  //         color: #fefefe !important;
  //         margin-left: 105px  !important;
  //         &:nth-child(1) {
  //           position: absolute !important;
  //           top: 15px !important;
  //           left: -50px !important;
  //         }
  //         &:nth-child(2) {
  //           margin-bottom: 16px !important;
  //         }
  //         &:nth-child(4) {
  //           margin-top: 23px !important;
  //           margin-bottom: 15px !important;
  //         }
  //       }
  //     }
  //   }
  // }
  // .footer-content {
  //   ul {
  //     margin-right: 45px  !important;
  //     li {
  //       width: 180px !important;
  //       font-family: HarmonyOS_Sans_SC;
  //       font-weight: 400 !important;
  //       font-size: 15px !important;
  //       color: #fefefe !important;
  //       opacity: 0.7 !important;
  //       margin-bottom: 20px  !important;
  //       &:nth-child(1) {
  //         font-family: HarmonyOS_Sans_SC;
  //         font-weight: 400 !important;
  //         font-size: 15px !important;
  //         color: #fefefe !important;
  //         opacity: 1 !important;
  //         margin-bottom: 35px  !important;
  //       }
  //     }
  //   }
  // }

  // .footer-child2 {
  //   width: 100% !important;
  //   max-width: 1208px !important;
  //   height: 136px !important;
  //   margin: auto !important;
  //   ul {
  //     width: 100% !important;
  //     height: auto !important;
  //     display: flex !important;
  //     font-family: HarmonyOS_Sans_SC;
  //     font-weight: 400 !important;
  //     font-size: 14px !important;
  //     color: #ffffff !important;
  //     display: flex !important;
  //     justify-content: center !important;
  //     align-items: center !important;
  //     li {
  //       padding: 0 15px !important;
  //       border-right: 1px solid #6e747d !important;
  //       &:last-child {
  //         border-right: none !important;
  //       }
  //     }
  //     &:nth-child(1) {
  //       padding-top: 30px !important;
  //     }
  //     &:nth-child(2) {
  //       margin-top: 24px !important;
  //     }
  //     &:nth-child(3) {
  //       margin-top: 13px !important;
  //     }
  //   }
  // }

  // 	  `;
  //   document.head.appendChild(style);

  const footersContent = `
					    <div class="footer">
                <div class="footer-child1">
                    <div class="footer-content">
                        <div class="footer-content-left">
                            <ul>
                                <li>数字化生产</li>
                                <li>网源联动控制系统</li>
                                <li>用户自主调节系统</li>
                                <li>户间水力平衡调节系统</li>
                                <li>一级网水力平衡调节系统</li>
                            </ul>
                            <ul>
                                <li>数据产品</li>
                                <li>生产运维智能体</li>
                                <li>经营财务智能体</li>
                                <li>老板助手智能体</li>
                            </ul>
                            <ul>
                                <li>热门产品</li>
                                <li>HT-OA</li>
                                <li>HT-HR</li>
                                <li>HT-Mind</li>
                                <li>HT-Office</li>
                            </ul>
                            <ul>
                                <li>解决方案</li>
                                <li>人力资源解决方案</li>
                                <li>企业供应链管理解决方案</li>
                                <li>经营财务解决方案</li>
                                <li>数字化转型解决方案</li>
                            </ul>
                        </div>
                        <div class="footer-content-right">
                            <div>
                                <img src="../imgs/homepage/电话.png" alt="">
                            </div>
                            <div>服务热线</div>
                            <div>13159870113</div>
                            <div>服务时间</div>
                            <div>每周一至周五<br />
                                09:00-18:00</div>
                        </div>
                    </div>
                </div>
                <div class="footer-child2">
                    <ul>
                        <li>行通科技</li>
                        <li>嫩江盛烨</li>
                        <li>林口盛烨</li>
                        <li>哈尔滨龙唐</li>
                        <li>耶耶烨</li>
                        <li>易购通</li>
                    </ul>
                    <ul>
                        <li>ICP备案：黑ICP备14032978号-14</li>
                    </ul>
                    <ul>
                        <li>《集团隐私权政策》《集团客户权益保障承诺书》</li>
                    </ul>
                </div>
            </div>
				`;
  return footersContent;
}

export default footers;
